/*
  Comparison table (sections/custom-comparison-table.liquid): on narrow
  screens, tabs switch which plan column is shown next to the row labels.
*/
(() => {
  if (customElements.get('comparison-table')) return;

  const narrow = window.matchMedia('(max-width: 749px)');

  class ComparisonTable extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelector('.comparison__tabs');
      this.buttons = [...this.querySelectorAll('.comparison__tab')];
      this.onChange = this.onChange.bind(this);

      this.buttons.forEach((button) =>
        button.addEventListener('click', () => this.select(button.dataset.plan))
      );
      narrow.addEventListener('change', this.onChange);
      this.onChange();
    }

    disconnectedCallback() {
      narrow.removeEventListener('change', this.onChange);
    }

    onChange() {
      const tabbed = narrow.matches && this.buttons.length > 1;
      this.classList.toggle('is-tabbed', tabbed);
      if (this.tabs) this.tabs.hidden = !tabbed;
    }

    select(plan) {
      this.dataset.active = plan;
      this.buttons.forEach((button) =>
        button.setAttribute('aria-pressed', String(button.dataset.plan === plan))
      );
    }
  }

  customElements.define('comparison-table', ComparisonTable);
})();
